webpackJsonp([185444044908787],{

/***/ 482:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Starter Blog","author":"Kyle Mathews"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2017-11-13-wod/index.md absPath of file >>> MarkdownRemark","html":"<h2>Monday 11/13</h2>\n<p>For time:</p>\n<p>20 Overhead KB squats</p>\n<p>10 Dumbbell press</p>\n<p>30 Overhead KB squats</p>\n<p>15 Dumbbell press</p>\n<p>50 Overhead KB squats</p>\n<p>25 Dumbbell press</p>\n<p>30 Overhead KB squats</p>\n<p>15 Dumbbell press</p>\n<p>20 Overhead KB squats</p>\n<p>10 Dumbbell press</p>\n<p>Use two 35 lbs dumbbells for the press, and a 50lb kettlebell for the squats.</p>","frontmatter":{"title":"WOD 11.13.2017","date":"November 13, 2017"}}},"pathContext":{"path":"/wod-2017-11-13/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---wod-2017-11-13-42be14f64c572fb18fde.js